<template>
  <section>
    <NavBar />
    <section class="hero is-bold" :class="$style.customHero">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div id="textblock" class="column">
              <h2 class="title">Extractor {{ extractor.name }}</h2>
              <h5 class="subtitle">
                {{ extractor.description }}
              </h5>
            </div>
            <div class="column has-text-centered">
              <img
                style="max-width: 40%;"
                :src="extractor.logo"
                alt="hero"
                title="integrations hero"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container py-6">
        <div class="columns">
          <div class="column">
            <h3 class="title is-4">
              Otras Integraciones
            </h3>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline is-inline-flex-mobile">
          <div
            v-for="extractor in extractors"
            :key="extractor.id"
            class="column is-6-mobile is-3-tablet"
          >
            <div class="tile is-ancestor">
              <div class="tile is-parent has-text-centered">
                <router-link
                  :to="{
                    name: 'integration',
                    params: { slug: extractor.slug },
                  }"
                >
                  <article
                    class="tile is-child notification is-primary is-light"
                    :class="[$style.tilePadding, $style.tileStyles]"
                  >
                    <img
                      :class="$style.tileImage"
                      :src="extractor.logo"
                      alt="logo"
                    />
                    <p class="subtitle">
                      <span
                        class="tag is-rounded"
                        :class="{
                          'is-success': extractor.type === 'API',
                          'is-dark': extractor.type === 'RPA',
                        }"
                      >
                        {{ extractor.type }}</span
                      >
                    </p>
                  </article>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </section>
</template>

<script>
import { NavBar, Footer } from "@/components";
import { heroIntegrations, sourcesLogos } from "@/assets/images";
import { extractors } from "@/utils";

export default {
  name: "Integration",
  computed: {
    extractor() {
      return extractors.find((e) => e.slug === this.$route.params.slug);
    },
  },
  data: () => {
    return {
      heroImage: heroIntegrations,
      sources: sourcesLogos,
      extractors,
    };
  },
  components: {
    NavBar,
    Footer,
  },
};
</script>

<style lang="scss" module>
@import "../styles/home.scss";

.customHero {
  background: linear-gradient(
    0deg,
    rgba(27, 115, 232, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}
</style>
